export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_veltech-ghana-demo/artifacts/efg78isd_Veltech%20Logo%201.2%20For%20Footer%20Navigation.png"
                alt="VelTech Ghana"
                className="w-10 h-10 object-contain"
              />
              <span
                className="text-lg font-black text-white tracking-tight uppercase"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                VelTech Ghana
              </span>
            </div>
            <p
              className="text-gray-500 text-sm leading-relaxed max-w-sm font-medium"
              style={{ fontFamily: "'Satoshi', sans-serif" }}
            >
              Complete cloud-based school management system for Ghanaian schools.
              Empowering educators, engaging parents, inspiring students.
            </p>
          </div>

          <div>
            <h4
              className="text-xs font-black uppercase tracking-wider text-gray-400 mb-5"
              style={{ fontFamily: "'Satoshi', sans-serif" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-3">
              {["Features", "Testimonials", "FAQ", "Contact"].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    className="text-sm text-gray-500 hover:text-white transition-colors font-bold"
                    style={{ fontFamily: "'Satoshi', sans-serif" }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4
              className="text-xs font-black uppercase tracking-wider text-gray-400 mb-5"
              style={{ fontFamily: "'Satoshi', sans-serif" }}
            >
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@veltechgh.com" className="text-sm text-gray-500 hover:text-white transition-colors font-medium" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                  info@veltechgh.com
                </a>
              </li>
              <li>
                <a href="tel:+233531988775" className="text-sm text-gray-500 hover:text-white transition-colors font-medium" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                  0531 988 775
                </a>
              </li>
              <li>
                <a href="https://wa.me/233505066691" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-white transition-colors font-medium" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                  WhatsApp: 0505 066 691
                </a>
              </li>
              <li className="text-sm text-gray-500 font-medium" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                Accra, Ghana
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px bg-white/10 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600 font-bold" style={{ fontFamily: "'Satoshi', sans-serif" }}>
            &copy; {new Date().getFullYear()} VelTech Ghana. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/privacy" data-testid="footer-privacy" className="text-xs text-gray-600 hover:text-gray-400 transition-colors font-bold" style={{ fontFamily: "'Satoshi', sans-serif" }}>
              Privacy Policy
            </a>
            <a href="/terms" data-testid="footer-terms" className="text-xs text-gray-600 hover:text-gray-400 transition-colors font-bold" style={{ fontFamily: "'Satoshi', sans-serif" }}>
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
